/* Coco y Mimos — behaviour. Every section is complete and usable without this file. */
(function () {
  if (window.__cmReady) return; window.__cmReady = true;
  document.documentElement.classList.add('cm-js');
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function store(k, v) { try { if (v === undefined) return localStorage.getItem(k); if (v === null) localStorage.removeItem(k); else localStorage.setItem(k, v); } catch (e) { return null; } }

  /* ---------- the chapita: pet name + perro/gato sorts the page ---------- */
  var pet = { name: store('cm-pet-name') || '', kind: store('cm-pet-kind') || 'todo' };
  var LABEL = { perro: 'perros', gato: 'gatos' };

  function clean(s) { return (s || '').replace(/[<>]/g, '').replace(/\s+/g, ' ').trim().slice(0, 14); }

  function paintName(animate) {
    document.querySelectorAll('[data-cm-petname]').forEach(function (el) {
      var text = pet.name ? pet.name : el.getAttribute('data-default');
      if (el.textContent === text) return;
      if (!animate || reduce) { el.textContent = text; return; }
      el.classList.add('is-changing');
      setTimeout(function () { el.textContent = text; el.classList.remove('is-changing'); }, 180);
    });
  }

  function paintCatalogue() {
    document.querySelectorAll('[data-cm-cat]').forEach(function (cat) {
      cat.querySelectorAll('[data-cm-filter] button').forEach(function (b) {
        b.setAttribute('aria-pressed', String(b.getAttribute('data-kind') === pet.kind));
      });
      var shown = 0;
      cat.querySelectorAll('[data-cm-group]').forEach(function (g) {
        var n = 0;
        g.querySelectorAll('[data-kinds]').forEach(function (li) {
          var ok = pet.kind === 'todo' || li.getAttribute('data-kinds').indexOf(pet.kind) !== -1;
          li.hidden = !ok; if (ok) n++;
        });
        g.hidden = n === 0;
        var c = g.querySelector('[data-count]'); if (c) c.textContent = n === 1 ? '1 producto' : n + ' productos';
        shown += n;
      });
      var line = cat.querySelector('[data-cm-for]');
      if (line) {
        var n = shown === 1 ? '1 producto' : shown + ' productos';
        if (pet.kind === 'todo') line.textContent = pet.name ? 'Elige perro o gato y te mostramos solo lo de ' + pet.name + '.' : '';
        else line.textContent = (pet.name ? 'Lo que le sirve a ' + pet.name + ': ' : 'Para ' + LABEL[pet.kind] + ': ') + n + '.';
      }
    });
  }

  function setKind(kind) {
    pet.kind = kind; store('cm-pet-kind', kind === 'todo' ? null : kind);
    document.querySelectorAll('[data-cm-chapa] input[name="especie"]').forEach(function (r) { r.checked = r.value === kind; });
    paintCatalogue();
  }

  document.querySelectorAll('[data-cm-chapa]').forEach(function (form) {
    var input = form.querySelector('input[name="nombre"]');
    if (input && pet.name) input.value = pet.name;
    form.querySelectorAll('input[name="especie"]').forEach(function (r) {
      r.checked = r.value === pet.kind;
      r.addEventListener('change', function () { if (r.checked) setKind(r.value); });
    });
    if (input) {
      var t;
      input.addEventListener('input', function () {
        clearTimeout(t);
        t = setTimeout(function () { pet.name = clean(input.value); store('cm-pet-name', pet.name || null); paintName(true); paintCatalogue(); }, 220);
      });
    }
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var target = document.getElementById('catalogo');
      if (target) target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
    });
  });
  document.querySelectorAll('[data-cm-filter] button').forEach(function (b) {
    b.addEventListener('click', function () { setKind(b.getAttribute('data-kind')); });
  });
  paintName(false); paintCatalogue();

  /* ---------- hero: slow crossfade between two real scenes ---------- */
  document.querySelectorAll('[data-cm-slides]').forEach(function (box) {
    var slides = box.querySelectorAll('.cm-slide');
    if (slides.length < 2 || reduce) return;
    var i = 0, timer = null, hovering = false;
    function next() { if (hovering || document.hidden) return; slides[i].classList.remove('is-on'); i = (i + 1) % slides.length; slides[i].classList.add('is-on'); }
    function start() { stop(); timer = setInterval(next, 5600); }
    function stop() { if (timer) clearInterval(timer); timer = null; }
    box.addEventListener('pointerenter', function () { hovering = true; });
    box.addEventListener('pointerleave', function () { hovering = false; });
    box.addEventListener('focusin', function () { hovering = true; });
    box.addEventListener('focusout', function () { hovering = false; });
    document.addEventListener('visibilitychange', function () { if (document.hidden) stop(); else start(); });
    start();
  });

  /* ---------- favoritas: choose a name, the object and the heart change ---------- */
  document.querySelectorAll('[data-cm-fav]').forEach(function (fav) {
    var tabs = fav.querySelectorAll('[role="tab"]');
    var imgs = fav.querySelectorAll('.cm-fav__img');
    var facts = fav.querySelectorAll('[role="tabpanel"]');
    var heart = fav.querySelector('.cm-fav__stage');
    function pick(n, focus) {
      tabs.forEach(function (t, k) { t.setAttribute('aria-selected', String(k === n)); t.tabIndex = k === n ? 0 : -1; });
      imgs.forEach(function (im, k) { im.classList.toggle('is-on', k === n); });
      facts.forEach(function (f, k) { f.hidden = k !== n; });
      if (heart) heart.style.setProperty('--heart', tabs[n].getAttribute('data-heart'));
      if (focus) tabs[n].focus();
    }
    tabs.forEach(function (t, k) {
      t.addEventListener('click', function () { pick(k); });
      t.addEventListener('keydown', function (e) {
        var d = (e.key === 'ArrowDown' || e.key === 'ArrowRight') ? 1 : (e.key === 'ArrowUp' || e.key === 'ArrowLeft') ? -1 : 0;
        if (!d) return; e.preventDefault(); pick((k + d + tabs.length) % tabs.length, true);
      });
    });
  });

  /* ---------- envíos: when does it arrive, for this comuna ---------- */
  var HOLIDAYS = ['2026-10-31', '2026-11-01', '2026-12-08', '2026-12-25', '2027-01-01', '2027-04-02', '2027-04-03', '2027-05-01', '2027-05-21'];
  var DAYS = ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'];
  var MONTHS = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'];
  function chileNow() { return new Date(new Date().toLocaleString('en-US', { timeZone: 'America/Santiago' })); }
  function iso(d) { return d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0'); }
  function workday(d) { var w = d.getDay(); return w !== 0 && w !== 6 && HOLIDAYS.indexOf(iso(d)) === -1; }
  function addWork(start, n) { var d = new Date(start); while (n > 0) { d.setDate(d.getDate() + 1); if (workday(d)) n--; } return d; }
  function day(d, month) { return DAYS[d.getDay()] + ' ' + d.getDate() + (month ? ' de ' + MONTHS[d.getMonth()] : ''); }
  function eta(zone) {
    var now = chileNow(), ship = new Date(now);
    if (now.getHours() >= 14 || !workday(now)) ship = addWork(now, 1);
    var r = zone === 'rm' ? [1, 3] : [3, 7];
    var a = addWork(ship, r[0]), b = addWork(ship, r[1]);
    return 'entre el ' + day(a, a.getMonth() !== b.getMonth()) + ' y el ' + day(b, true);
  }
  document.querySelectorAll('[data-cm-eta]').forEach(function (box) {
    var sel = box.querySelector('select'), out = box.querySelector('[data-cm-eta-out]');
    var saved = store('cm-comuna'); if (saved && sel.querySelector('option[value="' + saved + '"]')) sel.value = saved;
    function upd(anim) {
      var text = eta(sel.selectedOptions[0].getAttribute('data-zone'));
      if (!anim || reduce) { out.textContent = text; return; }
      out.classList.add('is-changing');
      setTimeout(function () { out.textContent = text; out.classList.remove('is-changing'); }, 180);
    }
    upd(false);
    sel.addEventListener('change', function () { store('cm-comuna', sel.value); upd(true); });
  });

  /* ---------- footer: the time in Santiago against the 14:00 cut-off ---------- */
  document.querySelectorAll('[data-cm-clock]').forEach(function (box) {
    var t = box.querySelector('b'), note = box.querySelector('[data-cm-clock-note]');
    function tick() {
      var now = chileNow();
      t.textContent = String(now.getHours()).padStart(2, '0') + ':' + String(now.getMinutes()).padStart(2, '0');
      if (!note) return;
      if (workday(now) && now.getHours() < 14) {
        var left = (13 - now.getHours()) * 60 + (60 - now.getMinutes());
        note.textContent = 'Si pagas en las próximas ' + (left >= 60 ? Math.floor(left / 60) + ' h ' + (left % 60) + ' min' : left + ' min') + ', tu pedido sale hoy.';
      } else note.textContent = 'Lo que pagues ahora sale el próximo día hábil.';
    }
    tick(); setInterval(tick, 30000);
  });

  /* ---------- add to cart: say that it is working ---------- */
  document.querySelectorAll('form[data-cm-cart]').forEach(function (form) {
    form.addEventListener('submit', function () {
      var b = form.querySelector('button[type="submit"]');
      if (b) { b.setAttribute('aria-busy', 'true'); b.textContent = 'Agregando…'; }
    });
  });

  /* ---------- FAQ: one card open at a time ---------- */
  document.querySelectorAll('[data-cm-cards]').forEach(function (box) {
    var cards = box.querySelectorAll('details');
    cards.forEach(function (d) { d.addEventListener('toggle', function () { if (d.open) cards.forEach(function (o) { if (o !== d) o.open = false; }); }); });
  });

  /* ---------- entrances: each part rises once as it reaches the reader, in reading order ---------- */
  var parts = document.querySelectorAll('.cm-in, .cm-pop');
  if (!('IntersectionObserver' in window)) { parts.forEach(function (el) { el.classList.add('is-in'); }); return; }
  parts.forEach(function (el) {
    var sibs = Array.prototype.filter.call(el.parentElement.children, function (c) { return c.classList.contains('cm-in') || c.classList.contains('cm-pop'); });
    var i = sibs.indexOf(el);
    if (el.closest('.cm-hero')) i = Array.prototype.indexOf.call(el.closest('.cm-hero').querySelectorAll('.cm-in, .cm-pop'), el);
    el.style.setProperty('--i', Math.min(i, 6));
  });
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      e.target.classList.add('is-in');
      if (e.target.classList.contains('cm-shop__photo')) e.target.classList.add('is-in');
      io.unobserve(e.target);
    });
  }, { rootMargin: '0px 0px -8% 0px' });
  parts.forEach(function (el) { io.observe(el); });
})();
